<template>
  <div
    :class="['group bg-gray-700 border-2 rounded-lg shadow-lg w-64 relative overflow-visible', selected ? 'border-yellow-400' : data.__validationError ? 'border-red-500' : 'border-gray-600']"
  >
    <!-- Header del nodo -->
    <div class="bg-gray-800 p-3 rounded-t-lg flex items-center gap-2 justify-between">
      <div class="flex items-center gap-2">
        <span class="material-icons text-yellow-400">edit_note</span>
        <strong class="text-white">{{ $t('flowEditor.nodes.setVariableNode.title') }}</strong>
      </div>
      <ExitNodeBadge :active="data.__isExitNode" />
      <ValidationMarker :error="data.__validationError" />
    </div>
    
    <!-- Corpo del nodo -->
    <div class="p-3 text-sm">
      <p class="text-gray-400">{{ $t('flowEditor.nodes.setVariableNode.setLabel') }}</p>
      <p class="font-mono text-white truncate">{{ data.variableName || $t('flowEditor.nodes.setVariableNode.emptyVariable') }}</p>
      <p class="text-gray-400 mt-1">{{ $t('flowEditor.nodes.setVariableNode.toValueLabel') }}</p>
      <p class="font-mono text-white truncate">{{ data.value || $t('flowEditor.nodes.setVariableNode.emptyValue') }}</p>
    </div>

    <!-- Punti di connessione (Handles) -->
    <Handle type="target" :position="Position.Left" />
    <Handle type="source" :position="Position.Right" />
    <!-- Add node button -->
    <AddNodeButton v-if="!hasOutgoingEdge" @add="emit('add-node', nodeId)" />
  </div>
</template>

<script setup>
import { Handle, Position } from '@vue-flow/core';
import ExitNodeBadge from './ExitNodeBadge.vue';
import AddNodeButton from './AddNodeButton.vue';
import ValidationMarker from './ValidationMarker.vue';

const emit = defineEmits(['add-node']);

defineProps({
  data: { type: Object, required: true },
  selected: { type: Boolean, default: false },
  nodeId: { type: String, required: true },
  hasOutgoingEdge: { type: Boolean, default: false },
});
</script>